import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6029786c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "Dark Mode", -1))
const _hoisted_2 = ["src"]

import useDarkMode from '@/composables/useDarkMode';

/**
 * COMPOSABLES
 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { darkMode, toggleDarkMode } = useDarkMode();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("button", {
      class: "switch-container",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleDarkMode) && _unref(toggleDarkMode)(...args)))
    }, [
      _createElementVNode("div", {
        class: "switch-circle",
        style: _normalizeStyle(_unref(darkMode) ? {} : { transform: 'translateX(calc(100% - 4px)' })
      }, [
        _createElementVNode("img", {
          src: require(`@/assets/images/icons/moon-icon.svg`),
          class: "",
          alt: ""
        }, null, 8, _hoisted_2)
      ], 4)
    ])
  ], 64))
}
}

})